import React from "react";
import ChildrenProps from "@lib-shared/types/children-props";
import LightSpinner from "./light-spinner";

type NoticeProps = {
    xl?: string;
    lg?: string;
    showSpinner?: boolean;
    centerSpinner?: boolean;
    className?: string;
} & ChildrenProps;

const Notice = (props: NoticeProps) => {

    const xl = props?.xl ?? "6";
    const lg = props?.lg ?? "6";

    const spinner = () => {
        if (props?.showSpinner !== true) {
            return null;
        }

        return <LightSpinner isCentered={props.centerSpinner} />;
    }

    let className = "temporary-notice";

    if (props?.className != null) {
        className += ` ${props.className}`;
    }

    return (
        <div className={className}>
            <div className="result">
                {props?.children}
                {spinner()}
            </div>
        </div>
    );
}

export default Notice;
